var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"btn-wrapper",class:_vm.btnStyle,attrs:{"id":_vm.btnId}},[_c('div',{staticClass:"btn-txt",domProps:{"innerHTML":_vm._s(_vm.btnLbl)},on:{"click":_vm.clickButton}})])])}
var staticRenderFns = []

export { render, staticRenderFns }